module.exports = function(app) {
	'use strict';
	app.value('eprPlanCoverageHelper', {});
	app.directive('eprPlanCoverage', function() {
		return {
			template: require('directives/employee/eprPlanCoverage.html'),
			restrict: 'A',
			replace: false,

			scope: {
				employee: '=eprPlanCoverage',
				editMode: '=?',
				edittingOnEditPage: '=?',
				showInactiveDependents: '=?',
				groupToShow: '=?'
			},

			controller: [
				'$state', '$scope', '$q', 'modal', 'services', '$filter', '$rootScope', 'employee', 'storage', 'sessionData',
				'addFlowCommander', 'planAdmin', 'uncoveredDependentModal', 'eprPlanCoverageHelper', 'coverageBuddy',
				function (
					$state, $scope, $q, modal, services, $filter, $rootScope, employee, storage, sessionData,
					addFlowCommander, planAdmin, uncoveredDependentModal, eprPlanCoverageHelper, coverageBuddy
				) {
                    var originalData = angular.copy($scope.employee.data);
                    var TODAY = new Date();
                    $scope.needEffectDate = false;
                    $scope.memberEffectDate = false;
                    $scope.groupEffectDate = false;
                    $scope.clickedRemoveCancel = false;
                    $scope.lifeEventReason = '';
                    $scope.lifeEventDate = '';
                    if (sessionData.appConfig && sessionData.appConfig.SEP) {
                        $scope.hasSEP = sessionData.appConfig.SEP.booleanValue;
                        //sessionData.appConfig.SEP.booleanValue;
                    }
                    else {
                        $scope.hasSEP = false;
                    }
                    $scope.outSideOpen = false;
                    $scope.showSEP = false;

                    if ($scope.hasSEP) {
                        services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                            function (response) {
                                if (response) {
                                    $scope.outSideOpen = response;
                                }
                            });
                        services.eprsvc.lifeEventRules().getLifeEventRules().then(
                            function (response) {
                                if (response && response.data && response.data.payload) {
                                    $scope.lifeEventValues = response.data.payload;
                                }
                            }
                        );
                    }



                    $scope.eMetadata = employee.metadata;
                    $scope.typesOfCoverage = coverageBuddy.typesOfCoverage;
                    $scope.prettyTypesOfCoverage = coverageBuddy.prettyTypesOfCoverage;
                    $scope.isEditFlowAddCoveragePage = $state.current && $state.current.name === 'employee.find.addCoverage';
                    eprPlanCoverageHelper.futureEffective = {};
                    var isComponent = function (coverg, lob) {
                        var checkOneMedical = function (coverages) {
                            var count = 0;
                            if (coverages.length > 1) {
                                coverages.forEach(function (cove) {
                                    if (coverageBuddy.coverageTypeMap.medical.indexOf(cove.lineOfBusiness) > -1) {
                                        count = count + 1;
                                    }
                                });
                            }
                            return count > 0 ? true : false;

                        };
                        if (sessionData.employerInfo.brandName === '6012') {
                        if (checkOneMedical(coverg.memberLobs)) {
                            return (lob.lineOfBusiness === 'VIS' || lob.lineOfBusiness === 'DEN') ? false : true;
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        	return true;
						}
                }

					$scope.shouldShowTrashButton = function(groupNumber, lob, coverg){
                    	if(lob.coverageType == 'MEDICAL'){
                    		eprPlanCoverageHelper.futureEffective[groupNumber] = {effectiveDate : lob.coverageEffectiveDate};
						}
						return Boolean(
							$scope.edittingOnEditPage &&
							planAdmin.canModifyGroupNumber(groupNumber) &&
							$scope.isProductActive(lob) &&
							!($scope.isProductMarkedForDeletion(groupNumber, lob) || $scope.isProductMarkedForAddition(groupNumber, lob)) && isComponent(coverg, lob)
						);
					};

					$scope.showRemoveCancelDate = function(date1, gpNumber ){
                        var today = new Date();
                        var showCancel = false;
                        if(date1 >= truncateToDay(today)){
                            showCancel = true;
                        }
                        else {
                            showCancel = false;
                        }

						return Boolean(planAdmin.canModifyGroupNumber(gpNumber) && $state.params.edit && showCancel);


					}
                    $scope.$watch('employee.data.globalCoverageEffectiveDate', function(n, o) {
                        if(o && o instanceof Date) {
                            if (n && n.toLocaleDateString("en-US") !== o.toLocaleDateString("en-US")) {
								if ($scope.clickedRemoveCancel) {

                                    employee.editInProgress.reset();
                                    employee.load(employee.data.umi);
                                    employee.editInProgress.init();
                                    $scope.clickedRemoveCancel = false;
                                    setTimeout(function() {
                                        $rootScope.$broadcast('updateProvidersonRevert');
                                    }, 1000);


                                }
							}
                        }
                    });

					$scope.planCoverage = {};
					eprPlanCoverageHelper.planCoverage = $scope.planCoverage;


					$scope.cascadeCheckbox = function(coverageType) {
						if (!$scope.planCoverageOptIn.subscriber[coverageType]) {
							for (var i = 0; i < $scope.planCoverageOptIn.dependents.length; i++) {
								$scope.planCoverageOptIn.dependents[i][coverageType] = false;
							}
						}
					};

					$scope.applyPlanRequirementsForDependent = function(plan, index, coverageType, productEffectiveDate) {
						var currentDependent = $scope.employee.data.dependents[index];
						var uncheckDependent = function() {
							$scope.planCoverageOptIn.dependents[index][coverageType] = false; // uncheck the dependent
						};
						services.eprsvc.additionalGroupInformation({ groupNumber: plan.groupNumber }).fetch(productEffectiveDate).then(
							function(response) {
								if (
									response &&
									response.data &&
									response.data.payload
								) {
									var typeOfModal = coverageBuddy.maybeGetModalType(response.data.payload, coverageType, currentDependent, $scope.employee.data.subscriber.gender);
									if (typeOfModal) {
										coverageBuddy.showCoverageModal(typeOfModal, $rootScope.$new());
										if(typeOfModal !== 'adultDental' && typeOfModal !== 'adultVision') {
                                            uncheckDependent();
                                        }
									}
								}
							}
						);
					};

					var uncheckAllBoxesForProduct = function(coverageType) {
						$scope.planCoverageOptIn.subscriber[coverageType] = false;
						$scope.planCoverageOptIn.dependents.forEach(function(d) {
							d[coverageType] = false;
						});
					};
                    function truncateToDay(date) {
                        date.setHours(0);
                        date.setMinutes(0);
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        return date;
                    }

					var handlePlanChange = function(coverageType, plan, productEffectiveDate) {
						if (coverageType !== 'uccidental') { // FIXME: when unselecting a plan, nothing happens.  Need an else to the below if...
							$rootScope.$broadcast('planChanged', coverageType, plan);
							if (plan && plan.groupNumber) {
								$scope.eMetadata.additionalGroupInformationIsLoading = true;
								services.eprsvc.additionalGroupInformation({ groupNumber: plan.groupNumber }).fetch(productEffectiveDate).then(
									function(response) {
										var additionalGroupInformation = response && response.data && response.data.payload;

										if (additionalGroupInformation) {
											if (coverageType === 'medical') {
												if (addFlowCommander.isInAddFlow() || $scope.isEditFlowAddCoveragePage) {
													$scope.hasChosenMajorMedical = addFlowCommander.isMajorMedicalRequired('lol nah', { majorMedical: plan.products.length > 1 });
													addFlowCommander.sidebar.update('jk', { majorMedical: $scope.hasChosenMajorMedical });
												}
												$rootScope.$broadcast('medicalPlanUpdated', additionalGroupInformation, angular.copy(plan), $scope.planCoverageOptIn, plan.groupNumber);
											}
											if (additionalGroupInformation.cancelDate) {
												coverageBuddy.showCoverageModal('cancelationNotice1', $rootScope.$new(), { cancelDate: additionalGroupInformation.cancelDate , groupNumber: plan.groupNumber });
											}
										}
										$scope.eMetadata.additionalGroupInformationIsLoading = false;
									},
									function(error) {
										$scope.eMetadata.additionalGroupInformationIsLoading = false;
										coverageBuddy.showCoverageModal('genericError', $rootScope.$new());
										console.error('additionalGroupInformation service failed with:', error);
									}
								).finally(function() { $scope.eMetadata.additionalGroupInformationIsLoading = false; });
							}
                            // code changes for RF1254817 ND CR
							else if(plan == null && coverageType == 'medical'){
                                $rootScope.$broadcast('medicalPlanUnchecked', false);
							}
						}
					};

					$scope.triggerPlanChange = function(coverageType, plan, productEffectiveDate) {
						handlePlanChange(coverageType, plan, productEffectiveDate);
						uncheckAllBoxesForProduct(coverageType);
					};

					$scope.fetchCoverages = function(coverageType, effDate, applyExistingData) {
						var removeCurrentPlanFromOptions = function(coverageType) {
							if (!Array.isArray($scope.employee.data.subscriber.memberCoverages)) { return; }
							for (var x = 0, memberCoverages = $scope.employee.data.subscriber.memberCoverages; x < memberCoverages.length; x++) {
								var coverage = memberCoverages[x];
								if (Array.isArray(coverage.memberLobs)) {
									for (var y = 0, memberLobs = coverage.memberLobs; y < memberLobs.length; y++) {
										if (
											memberLobs[y].coverageType.toLowerCase() == coverageType &&
											coverageBuddy.isLobActive(memberLobs[y])
										) {
											var existingProductIndex = $scope.planCoverage[coverageType].plans.findIndex(
												function(v) { return coverage.groupNumber == v.groupNumber; }
											);
											if (
												existingProductIndex != -1 &&
												!coverageBuddy.groupIsMajorMedical(coverage)
											) { // Splice out current plan from selection list
												$scope.planCoverage[coverageType].plans.splice(existingProductIndex, 1);
											}
										}
									}
								}
							}
						};

						var coveragePayload = {
							version: 'v2',
							coverageType: coverageType,
							effectiveDate: $filter('date')(effDate, 'MM-dd-yyyy'),
							zipCode: $scope.employee.data.subscriber.address.zipCode.base
						};
						return services.eprsvc.coverages(coveragePayload).fetch().then(
							function(response) {
								if (
									response &&
									response.data &&
									response.data.payload
								) {
									var decoratedPayload = angular.copy(response.data.payload);
									$scope.planCoverage[coverageType] = $scope.planCoverage[coverageType] || {};
									if (Array.isArray(decoratedPayload) && coverageType === 'uccidental') {
										decoratedPayload.forEach(function(group) {
											group.products[0].productName = 'Dental';
										});
									}
									$scope.planCoverage[coverageType].plans = decoratedPayload;
									if ($scope.isEditFlowAddCoveragePage) {
										removeCurrentPlanFromOptions(coverageType);
									}
								}
							},
							function() { // This call returns a 404 when there are no coverages, so evidently this clause is used to set the defaults for that case
								$scope.planCoverage[coverageType] = $scope.planCoverage[coverageType] || {};
								$scope.planCoverage[coverageType].plans = [];
							}
						).finally(
							function() {
								if (applyExistingData) { applyExistingData(coverageType); }
							}
						);
					};


                    $scope.removeCancelDate = function(lob, groupNumber) {
						$scope.lobLine = lob.lineOfBusiness;
                        $scope.needEffectDate = false;
                        $scope.memberEffectDate = false;
                        $scope.groupEffectDate = false;
                        $scope.clickedRemoveCancel = false;
                        if (!$scope.employee.data.globalCoverageEffectiveDate) {
                            $scope.needEffectDate = true;
                            'Effective date should not be empty';
                        } else {
                        	var cancelDt = '';
                            if (truncateToDay($scope.employee.data.globalCoverageEffectiveDate) >= truncateToDay(lob.coverageEndDate)) {
                                var p1 = services.eprsvc.additionalGroupInformation().getEffectiveDate(groupNumber);
                                services.eprsvc.additionalGroupInformation({ groupNumber: groupNumber }).fetch(p1).then(
                                    function (response) {
                                        if (response && response.data && response.data.payload && response.data.payload.cancelDate) {
                                            cancelDt = new Date(response.data.payload.cancelDate);

                                        }
                                        else {
                                        	cancelDt = '';
										}
                                        if (cancelDt) {
                                            if(truncateToDay($scope.employee.data.globalCoverageEffectiveDate) < truncateToDay(cancelDt)) {
                                                var memberLobsCoverage = coverageBuddy.getCoverageByGroupNumber(employee.editInProgress.data.subscriber, groupNumber);
                                                memberLobsCoverage.memberLobs.forEach(function (memberLob) {
                                                    if (memberLob.lineOfBusiness === lob.lineOfBusiness) {

                                                        memberLob.coverageEndDate = '';
                                                        memberLob.cancelReasonCode = '';
                                                        memberLob.coverageEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                                                    }
                                                    if(memberLobsCoverage.reportCodes){
                                                    	var rCode = memberLobsCoverage.reportCodes;
                                                    	rCode.forEach(function (rcod) {
                                                    		rcod.effectiveDate = $scope.employee.data.globalCoverageEffectiveDate.toLocaleDateString("en-US");
                                                    		rcod.cancel = true;
														});

													}

                                                    var dep = employee.editInProgress.data.dependents;
                                                    if (Array.isArray(dep)) {
                                                        dep.forEach(function (depen) {
                                                            var r = $scope.isDependentEnrolledInLob(depen, groupNumber, lob.lineOfBusiness);
                                                            if (r) {
                                                                if (Array.isArray(depen.memberCoverages)) {
                                                                    depen.memberCoverages.forEach(function (coverage) {
                                                                        if (coverage.groupNumber === groupNumber && Array.isArray(coverage.memberLobs)) {
                                                                            coverage.memberLobs.forEach(function (lobs) {
                                                                                if (lobs.lineOfBusiness === lob.lineOfBusiness) {
                                                                                    lobs.coverageEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                                                                                    lobs.coverageEndDate = '';



                                                                                }
                                                                            });
                                                                        }
                                                                    });
                                                                }
                                                            }
                                                        });
                                                    }
                                                });
                                                if(memberLobsCoverage.providerInformation){
													$rootScope.$broadcast('updateProviders', groupNumber,lob.lineOfBusiness);

												}
                                                $scope.clickedRemoveCancel = true;
                                            }
                                            else {
                                                $scope.canceldate = response.data.payload.cancelDate;
                                                $scope.groupEffectDate = true;
                                                'Effective Date should Be prior to cancel date';
                                            }
                                        }
                                        else {
                                            var memberLobs1 = coverageBuddy.getCoverageByGroupNumber(employee.editInProgress.data.subscriber, groupNumber);
                                            memberLobs1.memberLobs.forEach(function (memberLob) {
                                                if (memberLob.lineOfBusiness === lob.lineOfBusiness) {
                                                    memberLob.coverageEndDate = '';
                                                    memberLob.coverageEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                                                    memberLob.cancelReasonCode = '';

                                                }
                                                if(memberLobs1.reportCodes){
                                                    var rCode = memberLobs1.reportCodes;
                                                    rCode.forEach(function (rcod) {
                                                        rcod.effectiveDate = $scope.employee.data.globalCoverageEffectiveDate.toLocaleDateString("en-US");
                                                       rcod.cancel = true;
                                                    });

                                                }

                                                var dep = employee.editInProgress.data.dependents;
                                                if (Array.isArray(dep)) {
                                                    dep.forEach(function (depen) {
                                                        var r = $scope.isDependentEnrolledInLob(depen, groupNumber, lob.lineOfBusiness);
                                                        if (r) {
                                                            if (Array.isArray(depen.memberCoverages)) {
                                                                depen.memberCoverages.forEach(function (coverage) {
                                                                    if (coverage.groupNumber === groupNumber && Array.isArray(coverage.memberLobs)) {
                                                                        coverage.memberLobs.forEach(function (lobs) {
                                                                            if (lobs.lineOfBusiness === lob.lineOfBusiness) {
                                                                                lobs.coverageEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
                                                                                lobs.coverageEndDate = '';


                                                                            }

                                                                        });
                                                                    }
                                                                });
                                                            }
                                                        }
                                                    });
                                                }
                                            });
                                            if(memberLobs1.providerInformation){
                                                $rootScope.$broadcast('updateProviders', groupNumber,lob.lineOfBusiness);

                                            }
                                            $scope.clickedRemoveCancel = true;
                                        }
                                    },function (error) {
                                        console.error('additional group information failed:', error);
                                    }
                                );





                            }
                            else {
                                $scope.memberEffectDate = true;

                                'Effective date of changes should be greater that coverage End date';
                            }
                        }
                    }








                    $scope.fetchCoveragesAndClearProduct = function(coverageType, effDate) {
						$scope.planCoverageOptIn[coverageType + 'plan'] = "";
						uncheckAllBoxesForProduct(coverageType);
						$scope.fetchCoverages(coverageType, effDate);
					};

					var initialize = function() {
						var loadStoredOptIn = function() {
							var storedOptIn = angular.copy(storage.get('planCoverageOptIn')); // This is used for saving coverage page when leaving for provider search
							var coverageType = 'medical';  // hardcoded medical right now, assuming pcps are only assigned to medical, this may need fixed though
							var backupOptIn = angular.copy(storedOptIn); // Assign a copy, so we don't destroy the good version
							$scope.planCoverageOptIn = employee.metadata.planCoverageOptIn = storedOptIn;
							var storedPlan = storedOptIn[coverageType + 'plan'];
							handlePlanChange(coverageType, storedPlan, services.eprsvc.additionalGroupInformation().getEffectiveDate(storedPlan.groupNumber));
							// Trigger update, however this will clear some of the data we just prefilled
							// Bring back the cleared data from the good copy we made sure not to taint
							angular.extend(storedOptIn, backupOptIn);

							Object.keys($scope.planCoverageOptIn).forEach(function(key) {
								var coverageType, m = key.match(/(.*)plan/);
								if (m && (coverageType = m[1])) {
									$scope.planCoverageOptIn.subscriber[coverageType] = true;
									for (var i = 0; i < $scope.employee.data.dependents.length; i++) {
										$scope.planCoverageOptIn.dependents[i][coverageType] = true;
										$scope.applyPlanRequirementsForDependent($scope.planCoverageOptIn[coverageType + 'plan'], i, coverageType);
									}
								}
							});
							storage.del('planCoverageOptIn');
						};

						var maybeHandleStoredPcpSelections = function() {
							var storedpcpSelections = angular.copy(storage.get('pcpSelections'));
							if (storedpcpSelections) { // Dates are turned into iso format during save, calendar directive can't handle this, need to convert them back
								//Changed storedpcpSelections type to object
								for(var key in storedpcpSelections){
									var selection = storedpcpSelections[key];
									selection.effectiveDate = new Date(selection.effectiveDate);
								}
								employee.metadata.pcpData = storedpcpSelections;
								storage.del('pcpSelections');
							}
						};

						var createOptInObject = function() {
							if (storage.get('planCoverageOptIn')) {
								loadStoredOptIn();
							}
							else {
								$scope.planCoverageOptIn = employee.metadata.planCoverageOptIn = {
									subscriber: {},
									dependents: []
								};
								while ($scope.planCoverageOptIn.dependents.length < $scope.employee.data.dependents.length) {
									$scope.planCoverageOptIn.dependents.push({});
								}
								for (var w = 0; w < $scope.typesOfCoverage.length; w++) {
									$scope.planCoverageOptIn.subscriber[$scope.typesOfCoverage[w]] = false;
									for (var v = 0; v < $scope.employee.data.dependents.length; v++) {
										$scope.planCoverageOptIn.dependents[v][$scope.typesOfCoverage[w]] = false;
									}
								}
							}
							maybeHandleStoredPcpSelections();
						};

						var loadedCoverages = {
							medical: false,
							dental: false,
							uccidental: false,
							vision: false,
							drug: false,
							service: false
						};

						var applyExistingData = function(coverageType) {
							if (!Array.isArray($scope.employee.data.subscriber.memberCoverages)) {
								return;
							}
							for (var i = 0; i < $scope.employee.data.subscriber.memberCoverages.length; i++) {
								var currentCoverage = $scope.employee.data.subscriber.memberCoverages[i];
								for (var j = 0; j < currentCoverage.memberLobs.length; j++) {
									var currentLob = currentCoverage.memberLobs[j];
									if (currentLob.coverageType.toLowerCase() === coverageType) { // find coverageType's selected plan
										$scope.planCoverage[coverageType].plans.forEach(function(plan) {
											if (plan.groupNumber === currentCoverage.groupNumber) {
												$scope.planCoverageOptIn[coverageType + 'plan'] = plan;
												handlePlanChange(coverageType, plan, services.eprsvc.additionalGroupInformation().getEffectiveDate(plan.groupNumber));
												loadedCoverages[coverageType] = true;
												$scope.planCoverageOptIn.subscriber[coverageType] = true; // check box for subscriber if not a cancelled LOB
											}
										});
									}
								}
							}
							if (loadedCoverages[coverageType]) {
								coverageBuddy.goThroughDependentsLobsAndDo($scope.employee.data, function(lob, depIndex) {
									if (lob.coverageType.toLowerCase() === coverageType) {
										$scope.planCoverageOptIn.dependents[depIndex][coverageType] = true;
										$scope.applyPlanRequirementsForDependent($scope.planCoverageOptIn[coverageType + 'plan'], depIndex, coverageType);
									}
								});
							}
						};

						var numberOfProducts = $scope.typesOfCoverage.length;
						for (var x = 0; x < $scope.typesOfCoverage.length; x++) {
							$scope.planCoverage[$scope.typesOfCoverage[x]] = $scope.planCoverage[$scope.typesOfCoverage[x]] || {}; //not needed?

							var properEffectiveDate = $scope.planCoverage[$scope.typesOfCoverage[x]].effectiveDate;
							if (
								!(properEffectiveDate instanceof Date) ||
								(
									properEffectiveDate.getFullYear() === TODAY.getFullYear() &&
									properEffectiveDate.getMonth() === TODAY.getMonth() &&
									properEffectiveDate.getDate() === TODAY.getDate()
								)
							) {
								properEffectiveDate = $scope.employee.data.globalCoverageEffectiveDate;
							}

							$scope.planCoverage[$scope.typesOfCoverage[x]] = {
								effectiveDate: angular.copy(properEffectiveDate)
							};


							var cb = !$scope.isEditFlowAddCoveragePage && applyExistingData;
							if ($scope.editMode || $scope.isEditFlowAddCoveragePage) {
								$scope.eMetadata.fetchingCoverages = true;
								$scope.fetchCoverages(
									$scope.typesOfCoverage[x],
									$scope.planCoverage[$scope.typesOfCoverage[x]].effectiveDate || TODAY,
									cb
								).then(
									function() {
										if (--numberOfProducts == 0) {
											$scope.eMetadata.fetchingCoverages = false;
										}
									}
								);
							}
							else if (!$scope.cancelCodeReasonMap) {
								$scope.cancelCodeReasonMap = { '1': 1 }; //filling in dummy values so we don't keep calling the service
								$scope.cancelReasonList = [];
								services.eprsvc.cancelReasonCodes().fetch().then(
									function (response) {
										if(Array.isArray(response.data.payload)) {
											$scope.cancelCodeReasonMap = {};
											response.data.payload.forEach(function(obj) {
												$scope.cancelCodeReasonMap[obj.value] = obj.label;
												$scope.cancelReasonList.push(obj);
											});
										}
									},
									function (error) {
										console.error('eprsvc.cancelReasonCodes().fetch() failed with:', error);
									}
								);
							}
						}
						createOptInObject();
					};
					$scope.employee.ready.then(initialize);

					$scope.isDependentEligible = function(dependent, groupNumber, coverageType) {
						var eligible = true;
						if (Array.isArray(dependent.memberCoverages)) {
							dependent.memberCoverages.forEach(function(coverage) {
								if (coverage.groupNumber === groupNumber && Array.isArray(coverage.memberLobs)) {
									coverage.memberLobs.forEach(function(lob) {
										if (lob.coverageType.toLowerCase() === coverageType && lob.cancelReasonCode && lob.cancelReasonCode === "06") {
											eligible = false; //"06" is reason code for deceased, not eligible to reinstate
										}
									});
								}
							});
						}
						return eligible;
					};

					$scope.isDependentEnrolled = function(dependent, groupNumber, coverageType, isForCCC) {
						var enrolled = false;
						if (Array.isArray(dependent.memberCoverages)) {
							dependent.memberCoverages.forEach(function(coverage) {
								if (coverage.groupNumber === groupNumber && Array.isArray(coverage.memberLobs)) {

									var subscriberHasCurrentCoverage = false;
									if (isForCCC) {
										for (var i = 0; i < $scope.employee.data.subscriber.memberCoverages.length; ++i) {
											var subscriberGroupNumber = $scope.employee.data.subscriber.memberCoverages[i].groupNumber;
											if (subscriberGroupNumber === groupNumber && Array.isArray($scope.employee.data.subscriber.memberCoverages[i].memberLobs)) {
												$scope.employee.data.subscriber.memberCoverages[i].memberLobs.forEach(function(lob) {
													if (lob.coverageType.toLowerCase() == coverageType) {
														subscriberHasCurrentCoverage = lob.coverageEffectiveDate <= TODAY;
													}
												});
											}
										}
									}

									coverage.memberLobs.forEach(function(lob) {
										if (
											lob.coverageType.toLowerCase() === coverageType &&
											(!lob.coverageEndDate || (lob.coverageEndDate >= TODAY))
										) {
											if (isForCCC && subscriberHasCurrentCoverage) {
												enrolled = lob.coverageEffectiveDate <= TODAY;
											}
											else {
												enrolled = true;
											}
										}
									});
								}
							});
						}
						return enrolled;
					};



                    $scope.isDependentInitiallyEnrolled = function(dependent, groupNumber, lineOfBusiness, coverageType) {
                    	//RF1308194 changes for checking UCDdental
                        if(coverageType.toLowerCase() !== 'uccidental'){
                            return (
                                dependent.pin &&
                                $scope.isDependentEnrolledInLob(
                                    employee.getParticipantByPIN(dependent.pin, originalData),
                                    groupNumber,
                                    lineOfBusiness
                                )
                            );
                        }
                        else {
                            return (
                                $scope.isDependentEnrolledInLob(//RF1308194 cll to fetch dependent based on FirstName,Lname and Gender and DOB
                                    employee.getParticipantBDandGender(dependent, originalData),
                                    groupNumber,
                                    lineOfBusiness
                                )
                            );

                        }

                    };

                    $scope.shouldDependentShow = addFlowCommander.isInAddFlow()
                        ? function(d, gn, l, c) { return $scope.isDependentEnrolledInLob(d, gn, l); } // keep this closure here or suffer
                        : $scope.isDependentInitiallyEnrolled;

					$scope.isProductActive = coverageBuddy.isLobActive;

					var checkForProductInArray = function(groupNum, lob, arrayName) {
						var isMarked = false;
						if ($scope.employee.coverages && Array.isArray($scope.employee.coverages[arrayName])) {
							$scope.employee.coverages[arrayName].forEach(function(obj) {
								if (groupNum === obj.groupNumber && lob.lineOfBusiness === obj.lineOfBusiness) {
									isMarked = true;
								}
							});
						}
						return isMarked;
					};

					$scope.isProductMarkedForAddition = function(groupNum, lob) {
						return checkForProductInArray(groupNum, lob, "forAddition");
					};

					$scope.isProductMarkedForDeletion = function(groupNum, lob) {
						return checkForProductInArray(groupNum, lob, "forDeletion");
					};

					var broadcastEditFlowDependentUpdate = function(groupNumber, productEffectiveDate, optin, depend) {
						services.eprsvc.additionalGroupInformation({ groupNumber: groupNumber }).fetch(productEffectiveDate).then(
							function(response) {
								var additionalGroupInformation = response && response.data && response.data.payload;
								if (additionalGroupInformation) {
									if(additionalGroupInformation.tobaccoQuestionRequired){
                                        depend['optingIn'] =  true;
                                        if(!optin){
                                        	delete depend['optingIn'];
										}
									}
									$rootScope.$broadcast('editFlowDependentMedicalCoverageChange', additionalGroupInformation, optin);
									console.debug('sent editFlowDependentMedicalCoverageChange');
								}
							},
							function() {
								console.debug('failed in broadcastEdit....', productEffectiveDate);
							}
						);
					};

					$scope.updateCoverageOnDependent = function(dependent, coverage, lob, prod, optingIn) {
						if (optingIn) { //add lob to dependent
							if($scope.hasSEP && $scope.outSideOpen && optingIn){
                                $scope.showSEP = true;
                                 if(!dependent.hasOwnProperty('eventDate')){
                                     dependent['eventCode'] = 'updateSepCode';
                                     dependent['eventDate']= 'updateSepDate';
								 }

                            }
							var added = false;
							var cancelled = false;
							var potentialNewLob = angular.copy(lob);
							potentialNewLob.coverageEffectiveDate = 'updateMe';

							if (Array.isArray(dependent.memberCoverages)) {
								dependent.memberCoverages.forEach(function(cov) {
									if (cov.groupNumber === coverage.groupNumber && Array.isArray(cov.memberLobs)) {
										cov.memberLobs.forEach(function(depLob) {
											if (depLob.lineOfBusiness === lob.lineOfBusiness && depLob.cancelReasonCode) {
												cancelled = true;
											}
										});
										if (!cancelled) {
											cov.memberLobs.push(potentialNewLob);
											added = true;
										}
										else {
											for (var x = 0; x < cov.memberLobs.length; x++) {
												if (cov.memberLobs[x].lineOfBusiness === lob.lineOfBusiness && cov.memberLobs[x].cancelReasonCode) {
													cov.memberLobs.splice(x, 1);
												}
											}
										}
									}
								});
								if (!added) {
									dependent.memberCoverages.push({
										groupNumber: coverage.groupNumber,
										memberLobs: [potentialNewLob]
									});
								}
							}
							if ($state.current.name === 'employee.find.review' && prod === 'medical') {
								eprPlanCoverageHelper.preexistingMedicalCoverageEffectiveDate = lob.coverageEffectiveDate;
								broadcastEditFlowDependentUpdate(coverage.groupNumber, lob.coverageEffectiveDate, optingIn, dependent);
							}
						}
						else { //cut lob out of coverage

                            if($scope.hasSEP && $scope.outSideOpen && dependent.hasOwnProperty('eventDate')){
                                delete dependent['eventCode'];
                                delete dependent['eventDate'];
                                $scope.showSEP = false;
                            }
                            if ($state.current.name === 'employee.find.review' && prod === 'medical') {
                                broadcastEditFlowDependentUpdate(coverage.groupNumber, lob.coverageEffectiveDate, optingIn, dependent);
                            }
							if (Array.isArray(dependent.memberCoverages)) {
								dependent.memberCoverages.forEach(function(cov) {
									if (cov.groupNumber === coverage.groupNumber && Array.isArray(cov.memberLobs)) {
										for (var x = 0; x < cov.memberLobs.length; x++) {
											if (cov.memberLobs[x].lineOfBusiness === lob.lineOfBusiness) {
												cov.memberLobs.splice(x, 1);
											}
										}
									}
								});
							}
						}
					};


                    $scope.$watch('lifeEventReason', function (n) {

                           if(employee.editInProgress.data) {
                               var dep = employee.editInProgress.data.dependents;
                               if (Array.isArray(dep)) {
                                   dep.forEach(function (depen) {
                                       if (depen.hasOwnProperty('eventCode')) {
                                           depen.eventCode = $scope.lifeEventReason.lifeEventId;
                                       }
                                   });
                               }
                           }
                    }, true);
                    $scope.$watch('lifeEventDate', function (n) {
                    	if(n && n instanceof Date){
                            var normalizeOutgoingDate = function (date) {
                                return $filter('date')(date, 'MM/dd/yyyy');
                            };
                            if (employee.editInProgress.data) {
                                var dep = employee.editInProgress.data.dependents;
                                if (Array.isArray(dep)) {
                                    dep.forEach(function (depen) {
                                        if (depen.hasOwnProperty('eventDate')) {
                                            depen.eventDate = normalizeOutgoingDate($scope.lifeEventDate);
                                        }
                                    });
                                }
                            }
                        }
                    }, true);

					$scope.openCancelLOBModal = function(groupNum, lob, covrg) {
						$scope.covrge = angular.copy(covrg);
						$scope.tryingToVoid = false;
						$scope.voidComparisonLob = angular.copy(lob);
						if (sessionData &&
							sessionData.entitlements &&
							sessionData.entitlements.clientQualifiers &&
							sessionData.entitlements.clientQualifiers.aso)
						{
							$scope.asoValue = sessionData.entitlements.clientQualifiers.aso;
						}
						$scope.cancelLOBModalData = {
							groupNumber: groupNum,
							lineOfBusiness: lob.lineOfBusiness,
							cancelReasonCode: '',
							cancelDate: null
						};
						modal.open({
							template: require('pages/employee/modals/cancelLOBModal.html'),
							scope: $scope,
							classes: 'epr-standard-modal large-modal'
						});
					};

					$scope.cancelLOB = function(voidComparisonLob, covrg) {
						if ($scope.cancelLOBModalForm.$invalid) {
							return;
						} else if ($scope.cancelLOBModalData.cancelReasonCode === '03') { //voiding, check for date equivalence
							$scope.tryingToVoid = true;
							if ($scope.cancelLOBModalData.cancelDate.getFullYear() !== voidComparisonLob.coverageEffectiveDate.getFullYear() ||
								$scope.cancelLOBModalData.cancelDate.getMonth() !== voidComparisonLob.coverageEffectiveDate.getMonth() ||
								$scope.cancelLOBModalData.cancelDate.getDate() !== voidComparisonLob.coverageEffectiveDate.getDate()) {
									return;
								}
						}
						$scope.tryingToVoid = false;
						var firstCancellation = $scope.employee.coverages.forDeletion.length === 0;
						if ($scope.employee.isActive() && Array.isArray($scope.employee.coverages.forDeletion)) {
                            var isDuplicate = function (grNum, Lob) {
                                return $scope.isProductMarkedForDeletion(grNum,
                                                                         {lineOfBusiness: Lob});
                            };


							// var isDuplicate = $scope.isProductMarkedForDeletion($scope.cancelLOBModalData.groupNumber,
							// 	{lineOfBusiness: $scope.cancelLOBModalData.lineOfBusiness});
							if (!isDuplicate($scope.cancelLOBModalData.groupNumber, $scope.cancelLOBModalData.lineOfBusiness)) {
								$scope.employee.editInProgress.data.subscriber.memberCoverages.forEach(function (cov) {
										if(cov.groupNumber === $scope.cancelLOBModalData.groupNumber){
											if(cov.providerInformation){
                                                $rootScope.$broadcast('updateProvidersOnTrash', $scope.cancelLOBModalData.groupNumber, $scope.cancelLOBModalData.lineOfBusiness,$scope.cancelLOBModalData.cancelDate, $scope.cancelLOBModalData.cancelReasonCode);
											}
										}  })

								$scope.employee.coverages.forDeletion.push(angular.copy($scope.cancelLOBModalData));
							}
                            if (sessionData.employerInfo.brandName === '6012') {

                                covrg.memberLobs.forEach(function (memLob) { if(memLob.lineOfBusiness === 'VIS' || memLob.lineOfBusiness === 'DEN'){
                                    if(!isDuplicate(covrg.groupNumber,memLob.lineOfBusiness)){
                                        var sData =  {
                                            groupNumber: covrg.groupNumber,
                                            lineOfBusiness: memLob.lineOfBusiness,
                                            cancelReasonCode: $scope.cancelLOBModalData.cancelReasonCode,
                                            cancelDate: $scope.cancelLOBModalData.cancelDate
                                        };
                                        $scope.employee.coverages.forDeletion.push(angular.copy(sData));
                                    }
                                } })}
						}
						$scope.closeModal();

						if (firstCancellation) {
							$state.go('employee.find.addCoverage');
						}
					};

					$scope.isDependentEnrolledInLob = function(dependent, groupNumber, lineOfBusiness, isForCCC) {
						var enrolled = false;
						//RF1308194 additonal check if Dependent is present while adding a new dependent in edit flow
						if (dependent && Array.isArray(dependent.memberCoverages)) {
							dependent.memberCoverages.forEach(function(coverage) {
								if (coverage.groupNumber === groupNumber && Array.isArray(coverage.memberLobs)) {

									var subscriberHasCurrentCoverage = false;
									if (isForCCC) {
										for (var i = 0; i < $scope.employee.data.subscriber.memberCoverages.length; ++i) {
											var subscriberGroupNumber = $scope.employee.data.subscriber.memberCoverages[i].groupNumber;
											if (subscriberGroupNumber === groupNumber && Array.isArray($scope.employee.data.subscriber.memberCoverages[i].memberLobs)) {
												$scope.employee.data.subscriber.memberCoverages[i].memberLobs.forEach(function(lob) {
													if (lob.lineOfBusiness == lineOfBusiness) {
														subscriberHasCurrentCoverage = lob.coverageEffectiveDate <= TODAY;
													}
												});
											}
										}
									}

									coverage.memberLobs.forEach(function(lob) {
										if (
											lob.lineOfBusiness === lineOfBusiness &&
											(!lob.coverageEndDate || (lob.coverageEndDate >= TODAY))
										) {
											if (isForCCC && subscriberHasCurrentCoverage) {
												enrolled = lob.coverageEffectiveDate <= TODAY;
											}
											else {
												enrolled = true;
											}
										}
									});
								}
							});
						}
						return enrolled;
					};

					$scope.getCCCByLobAndGroupNumber = function(lineOfBusiness, groupNumber) {
						var subscriber = true;
						var spouse = false;
						var domPar = false;
						var depCount = 0;
						$scope.employee.data.dependents.forEach(function(dependent) {
							if ($scope.isDependentEnrolledInLob(dependent, groupNumber, lineOfBusiness, true)) {
								var relationshipCode = dependent.relationshipCode;
								if (relationshipCode == '01') {
									spouse = true;
								}
								else if (relationshipCode == '29') {
									domPar = true;
								}
								else {
									depCount++;
								}
							}
						});
						return coverageBuddy.getCoverageCategoryCode(subscriber, spouse, domPar, depCount);
					};

					$scope.$on('assignPlans', function() { // saving the data before sending user to next page, add flow
						var assignAndEmit = function() {
							$scope.employee.data.subscriber.memberCoverages = employeeToSave.subscriber.memberCoverages;
							$scope.employee.data.dependents.forEach(
								function(d, i) { d.memberCoverages = employeeToSave.dependents[i].memberCoverages; }
							);
							$scope.$emit('plansAssigned', true);
						};

						var abortAndEmit = function() {
							$scope.$emit('plansAssigned', false);
						};

						console.debug('heard assignPlans');
						var employeeToSave = angular.copy($scope.employee.data); // jshint ignore: line

						employeeToSave.subscriber.memberCoverages = [];
						employeeToSave.dependents.forEach(function (d) {
							d.memberCoverages = [];
						});

						var coverageType;
						for (var i = 0; i < $scope.typesOfCoverage.length; i++) { // determine each LOB's coverage category code
							coverageType = $scope.typesOfCoverage[i];
							var subscriber = false;
							var spouse = false;
							var domPar = false;
							var depCount = 0;
							if ($scope.planCoverageOptIn.subscriber[coverageType]) {
								subscriber = true;
							}
							for (var d = 0; d < $scope.planCoverageOptIn.dependents.length; d++) {
								if ($scope.planCoverageOptIn.dependents[d][coverageType]) {
									var relationshipCode = $scope.employee.data.dependents[d].relationshipCode;
									if (relationshipCode =='01') {
										spouse = true;
									}
									else if (relationshipCode == '29') {
										domPar = true;
									}
									else {
										depCount++;
									}
								}
							}
							$scope.planCoverage[coverageType].coverageCategoryCode = coverageBuddy.getCoverageCategoryCode(subscriber, spouse, domPar, depCount);
						}

						var setPlanData = function (participants, destinationArray) {
							for (var x = 0; x < participants.length; x++) {
								var participant = participants[x];
								for (var coverageType in participant) {
									if (participant.hasOwnProperty(coverageType)) {
										if (participant[coverageType]) { // if LOB is checked for subscriber
											var selectedGroupForCoverageType = $scope.planCoverageOptIn[coverageType + 'plan'];
											if (selectedGroupForCoverageType) { // if plan was selected in LOB's card
												var overwriteCoverage = true;
												var newCoverage = coverageBuddy.pluck(destinationArray[x].memberCoverages, 'groupNumber', selectedGroupForCoverageType.groupNumber);
												if (!newCoverage) {
													newCoverage = {
														groupNumber: selectedGroupForCoverageType.groupNumber,
														memberLobs: [],
														reportCodes: []
													};
													if (
														$scope.employee.metadata &&
														$scope.employee.metadata.reportCodeGroups &&
														$scope.employee.metadata.reportCodeGroups[selectedGroupForCoverageType.groupNumber]
													) {
														newCoverage.reportCodes = Object.keys($scope.employee.metadata.reportCodeGroups[selectedGroupForCoverageType.groupNumber]).reduce(function(a, c) {
															var val = $scope.employee.metadata.reportCodeGroups[selectedGroupForCoverageType.groupNumber][c];
															if (val.value) {
																a.push(val);
															}
															return a;
														}, []);
													}
													overwriteCoverage = false;
												}

												var newLobs = selectedGroupForCoverageType.products.map(function(p) {
													return {
														lineOfBusiness: p.icisProductType,
														coverageEffectiveDate: $scope.planCoverage[coverageType].effectiveDate,
														coverageCategoryCode: $scope.planCoverage[coverageType].coverageCategoryCode,
														productId: p.productId,
                                                        productName : p.productName,
														coverageType: coverageType.toUpperCase()
													};
												});
												newLobs.forEach(function(lob) {
													newCoverage.memberLobs.push(lob);
												});

												if (!overwriteCoverage) {
													destinationArray[x].memberCoverages.push(newCoverage);
												}
											}
										}
									}
								}
							}
						};

						setPlanData([$scope.planCoverageOptIn.subscriber], [employeeToSave.subscriber]);
						setPlanData($scope.planCoverageOptIn.dependents, employeeToSave.dependents);

						var selectedAtLeastOneProduct = false;
						var productSelectedWithNoMembers = false;
						var erroringProduct = '';

						for (var w = 0; w < $scope.typesOfCoverage.length; w++) { //If no coverage is selected for any LOB, show error\
							coverageType = $scope.typesOfCoverage[w];
							if ($scope.planCoverageOptIn[coverageType + 'plan']) {
								selectedAtLeastOneProduct = true;
							}
						}
						if (!selectedAtLeastOneProduct) {
							coverageBuddy.showCoverageModal('noProductSelected',$rootScope.$new());
							abortAndEmit();
						}
						else { //If a plan is selected, make sure at least one person has a box checked. Else, show error
							for (var z = 0; z < $scope.typesOfCoverage.length; z++) {
								coverageType = $scope.typesOfCoverage[z];
								if ($scope.planCoverageOptIn[coverageType + 'plan']) {
									if (!$scope.planCoverageOptIn.subscriber[coverageType]) {
										productSelectedWithNoMembers = true;
										erroringProduct = coverageType;
										employee.goThroughDependentsAndDo($scope.planCoverageOptIn, function(dep) {
											if (dep[coverageType]) {
												productSelectedWithNoMembers = false;
												erroringProduct = '';
											}
										});
									}
								}
								if (productSelectedWithNoMembers) {
									break;
								}
							}
							if (productSelectedWithNoMembers) {
								coverageBuddy.showCoverageModal('productWithNoMembers', $rootScope.$new(), { erroringProduct: erroringProduct });
								abortAndEmit();
							}
						}

						if (employeeToSave.dependents.some(function(d) { return d.memberCoverages.length === 0; })) {
							var deferred = $q.defer();
							uncoveredDependentModal.launch(employeeToSave, $rootScope.$new(), deferred);
							deferred.promise.then(assignAndEmit, abortAndEmit);
						}
						else {
							assignAndEmit(employeeToSave);
						}
					});


					$scope.$on('updatePlans', function() { //update employee object directly, pass back to edit summary page, edit flow
						var addPlanToPerson = function(person, coverageType, plan) {
							var alreadyMarkedForAddition = {};
							var alreadyOnEmployee = {};
                            var existingGroupCoverage = coverageBuddy.pluck(person.memberCoverages, 'groupNumber', plan.groupNumber);
                            // var pluackedMember = '';
                            // var existingGroupCoverage = '';
                            // var members = [employee.data.subscriber].concat(employee.data.dependents || []);
                            // members.forEach(function (mem) {
                            //     if(mem.pin === person.pin){
                            //         pluackedMember = mem;
                            //
                            //     }
                            // })
                            // if(pluackedMember) {
                            //
                            //     existingGroupCoverage = coverageBuddy.pluck(pluackedMember.memberCoverages, 'groupNumber', plan.groupNumber);
                            // }
							var isMajorMedical = existingGroupCoverage && coverageBuddy.groupIsMajorMedical(existingGroupCoverage);
							if (!isMajorMedical) {
								var newLobs = plan.products.map(function(p) {
									return {
										lineOfBusiness: p.icisProductType,
										coverageEffectiveDate: $scope.planCoverage[coverageType].effectiveDate,
										coverageCategoryCode: $scope.planCoverage[coverageType].coverageCategoryCode,
										productId: p.productId,
                                        productName : p.productName,
										coverageType: coverageType.toUpperCase()
									};
								});

								if (existingGroupCoverage) {
									newLobs.forEach(function(lob) {
										var existingMatchingLob = coverageBuddy.pluck(existingGroupCoverage.memberLobs, 'lineOfBusiness', plan.icisProductType);
										var isRenewingLob = existingMatchingLob && lob.coverageEffectiveDate > existingMatchingLob.coverageEndDate;
										if (!existingMatchingLob || isRenewingLob) {
											existingGroupCoverage.memberLobs.push(lob);
										}
										else {
											alreadyOnEmployee[lob.productId] = true;
										}
									});
                                    // var existAlready = person.memberCoverages.some(function(m) { return angular.equals(m, existingGroupCoverage); });
                                    // if(!existAlready) {
                                    //     person.memberCoverages.push(existingGroupCoverage);
                                    // }
								}
								else {
									person.memberCoverages.push({
										groupNumber: plan.groupNumber,
										memberLobs: newLobs
									});
								}

								newLobs.forEach(function(lob) {
									for (var i = 0, marked; i < $scope.employee.coverages.forDeletion.length; ++i) {
										marked = $scope.employee.coverages.forDeletion[i];
										if (
											marked.groupNumber === plan.groupNumber &&
											marked.lineOfBusiness === lob.lineOfBusiness
										) {
											(function(splicePoint) {
												$scope.employee.coverages.forDeletion.splice(splicePoint, 1);
											}(i));
											break;
										}
									}
								});

								newLobs.forEach(function(lob) {
									for (var i = 0, marked; i < $scope.employee.coverages.forAddition.length; ++i) {
										marked = $scope.employee.coverages.forAddition[i];
										if (
											marked.groupNumber === plan.groupNumber &&
											marked.lineOfBusiness === lob.lineOfBusiness
										) {
											alreadyMarkedForAddition[lob.productId] = true;
											break;
										}
									}
								});

								newLobs.forEach(function(lob) {
									if (
										!alreadyMarkedForAddition[lob.productId] &&
										!alreadyOnEmployee[lob.productId]
									) {
										$scope.employee.coverages.forAddition.push({
											groupNumber: plan.groupNumber,
											lineOfBusiness: lob.lineOfBusiness
										});
									}
								});
							};
						}

						var selectedAtLeastOneProduct = false;
						var productSelectedWithNoMembers = false;
						var erroringProduct = '';

						for (var w = 0; w < $scope.typesOfCoverage.length; w++) { //If no coverage is selected for any LOB, show error
							var coverageType = $scope.typesOfCoverage[w];
							if ($scope.planCoverageOptIn[coverageType + 'plan']) {
								selectedAtLeastOneProduct = true;
							}
						}
						if (!selectedAtLeastOneProduct) {
							coverageBuddy.showCoverageModal('noProductSelected',$rootScope.$new());
						}
						else { // If a plan is selected, make sure at least one person has a box checked. Else, show error
							for (var p = 0; p < $scope.typesOfCoverage.length; p++) {
								var coverageType = $scope.typesOfCoverage[p]; // jshint ignore: line
								if ($scope.planCoverageOptIn[coverageType + 'plan']) {
									if (!$scope.planCoverageOptIn.subscriber[coverageType]) {
										productSelectedWithNoMembers = true;
										erroringProduct = coverageType;
										employee.goThroughDependentsAndDo($scope.planCoverageOptIn, function(dep) {
											if (dep[coverageType]) {
												productSelectedWithNoMembers = false;
												erroringProduct = '';
											}
										});
									}
								}
								if (productSelectedWithNoMembers) {
									break;
								}
							}
							if (productSelectedWithNoMembers) {
								coverageBuddy.showCoverageModal('productWithNoMembers', $rootScope.$new(), { erroringProduct: erroringProduct });
								return;
							}
						}
						$scope.typesOfCoverage.forEach(function(coverageType) {
							var planToAdd = $scope.planCoverageOptIn[coverageType + 'plan'];
							if (planToAdd) {
								if ($scope.planCoverageOptIn.subscriber[coverageType]) {
									addPlanToPerson($scope.employee.data.subscriber, coverageType, planToAdd);
								}
								for (var x = 0; x < $scope.employee.data.dependents.length; x++) {
									var dependent = $scope.employee.data.dependents[x];
									if ($scope.planCoverageOptIn.dependents[x][coverageType]) {
										addPlanToPerson(dependent, coverageType, planToAdd);
									}
								}
							}
						});
						$scope.$emit('plansUpdated');
					});
				}
			]
		};
	});
};
